import HttpClienteSeguroClass from '../../Servicios/HttpClienteSeguroClass';

// Se usa para obtener listados de admisiones seg�n filtros
// CustomerId: Identificador de la Cliente
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ListadoAdmisiones = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/Admisiones/Listado', filtro).then(response => {
            resolve(response);
        });
    });
};


// Se usa para obtener una admisi�n especifica segun el identificador
// AdmissionId: Identificador de la admisi�n
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ObtenerAdmisionCif = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/Admisiones/Obtener/", registro).then(response => {
            resolve(response);
        }).catch(error => {
                resolve(error.response);
            });
    });
};

// Se usa para crear una admisi�n
// AdmissionId: Identificador de la admisi�n
// CustomerId: Identificador del cliente
// ProgramId: Identificador del programa
// CampusId: Identificador de la sede
// PeriodId: Identificador del per�odo
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
/**
 * 
 * @param {{ userId:string, companyId:string, classificationId:string, statusId:string, periodId:string, campusId:string, admissionId:string, customerId:string, programId:string }} admision 
 * @returns {Promise<{ data:string, status: number}>}
 */
export const crearAdmision = (admision) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/Admisiones/Crear/", admision).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se usa para actualizar una admisi�n
// AdmissionId: Identificador de la admisi�n
// CustomerId: Identificador del cliente
// ProgramId: Identificador del programa
// CampusId: Identificador de la sede
// PeriodId: Identificador del per�odo
// StatusId: Identificador del estado
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ActualizarAdmision = (IdAdmision, admision) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.put("/Admisiones/" + IdAdmision, admision).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se usa para eliminar una admisi�n por su identificador
// AdmissionId: Identificador de la admisi�n
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const EliminarAdmision = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/Admisiones/Eliminar/", registro).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se aprueba una admision
// AdmissionId: Identificador de la admisi�n
// Approved: Valor si fue aprobado o no
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const EstadoAprobacionAdmision = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/Admisiones/Aprobacion/", registro).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Buscar una admisi�n por cliente, programa y compa�ia
// CustomerId: Identificador del cliente
// ProgramId: Identificador del programa
// CompanyId: Identificador de la compa��a
export const buscarAdmision = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/Admisiones/Buscar/", registro).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Buscar la ultima admisi�n pendiente por cliente
// CustomerId: Identificador del cliente
// CompanyId: Identificador de la compa��a
export const buscarUltimaAdmisionPendiente = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/Admisiones/UltimaAdmPendiente/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

export default ListadoAdmisiones